/**
 * PageWrapper
 */
import * as React from 'react';

// Styles
import './styles.scss';

type Element = React.ReactElement | false;
interface Props {
    children: Element | Element[];
    top?: number;
    bottom?: number;
    width?: number;
    style?: Record<string, any>;
}

// eslint-disable-next-line react/prefer-stateless-function
export default class PageWrapper extends React.Component<Props> {
    render(): React.ReactElement {
        const {
            children,
            top,
            bottom,
            width,
            style: customStyle = {}
        } = this.props;
        const style = {
            ...(top || top === 0 ? { paddingTop: top } : {}),
            ...(bottom || bottom === 0 ? { paddingBottom: bottom } : {}),
            ...(width || width === 0 ? { maxWidth: width } : {}),
            ...customStyle
        };

        return (
            <div className="page-wrapper" style={style}>
                {children}
            </div>
        );
    }
}
